"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Flag = _interopRequireDefault(require("@insided/destination/icons/Flag"));

var NotificationCenterEndOfList = function NotificationCenterEndOfList() {
  return (0, _preact.h)("div", {
    className: "notification-center__end-of-list"
  }, (0, _preact.h)("div", {
    className: "notification-center__end-of-list__icon"
  }, (0, _preact.h)(_Flag.default, null)), (0, _preact.h)("div", {
    className: "notification-center__end-of-list__text"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.theEnd"
  }))));
};

var _default = NotificationCenterEndOfList;
exports.default = _default;